<template>
  <div class="login">
    <!-- <img src="../../assets/images/login-bg.jpg" alt=""> -->
    <div class="middle">
      <div class="title">用户登录</div>
      <div class="title-2">User Login</div>
      <!-- <van-form @submit="onSubmit"> -->
      <div class="login-field" style="margin-top:40px">
        <span>用户名</span>
        <div>
          <van-field ref="userId" @focus='onFocus($event)' v-model="userId" placeholder="请输入用户名" size="mini" />
        </div>
      </div>
      <div class="login-field">
        <span>密码</span>
        <div>
          <van-field ref="password" v-model="password" type="password" placeholder="请输入密码" size="mini" />
        </div>
      </div>
      <div class="login-field">
        <span>验证码</span>
        <div class="login-code">
          <van-field ref="code" v-model="code" placeholder="请输入验证码" size="mini" />
          <span @click="getCode">
            <img :src="idCodeImg" :class="'style'" style="height:100%" />
          </span>
        </div>
      </div>
      <div class="login-submit">
        <van-button type="primary" @click="onSubmit" native-type="submit">登陆</van-button>
      </div>
      <!-- </van-form> -->
    </div>
  </div>
</template>

<script>
import JSEncrypt from 'jsencrypt'

export default {
  data() {
    return {
      userId: '',
      password: '',
      code: '',
      uuid: '',
      idCodeImg: '',
    }
  },
  created() {
    this.getCode()
  },
  methods: {
    onSubmit() {
      this.login()
    },
    onFocus(event) {
      // Focus event
    },
    // 获取验证码
    getCode() {
      this.uuid = Math.random()
      let url = `/api-auth/validata/code?uuid=${this.uuid}`
      this.$api.get(url).then((res) => {
        this.idCodeImg = 'data:image/png;base64,' + res.data
      })
    },
    // 登陆
    login() {
      if (!this.userId) {
        this.$Toast('请输入账号')
        return
      }
      if (!this.password) {
        this.$Toast('请输入密码')
        return
      }
      if (!this.code) {
        this.$Toast('请输入验证码')
        return
      }
      // let baseUrl = `api-auth/login/getEncryptionPublicKey/tobosoft_xhz`
      this.$api.get(`/api-auth/login/getEncryptionPublicKey/${this.userId}`).then((data) => {
        let decrypt = new JSEncrypt()
        decrypt.setPrivateKey(data.data)
        let password = decrypt.encrypt(this.password)
        let params = {
          account: this.userId,
          password: password,
        }
        let url = `/api-auth/login/new/v2?uuid=${this.uuid}&captcha=${this.code}&grant_type=password`
        this.$api.post(url, params).then((res) => {
          if (res.code === '0000') {
            // 登陆成功后将用户信息保存在缓存和vuex中
            localStorage.setItem('sele_user_info', JSON.stringify(res.data))
            this.$store.commit('setUserInfo', res.data)
            // 跳转至主页
            this.$utils.routerPush('/mobile/')
          } else {
            this.getCode()
            this.code = ''
            if (res.data.code === '0010') {
              this.$refs.code.focus()
            }
          }
        })
      })
    },
  },
}
</script>

<style lang="less" scoped>
.login {
  width: 100%;
  height: 100%;
  background-image: url('../../assets/images/login-bg.jpg');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  // position: relative;
  display: flex;
  justify-content: center;
  // align-items: center;
  /deep/ .van-cell {
    background: #e8f0fe;
  }

  .middle {
    max-width: 500px;
    width: calc(100% - 40px);
    height: 400px;
    background-color: rgba(30, 32, 48, 0.42);
    border-radius: 10px;
    // position: absolute;
    margin-top: calc(50vh - 200px);
    .title,
    .title-2 {
      margin-top: 30px;
      width: 100%;
      line-height: 20px;
      color: white;
      text-align: center;
      letter-spacing: 2px;
      font-size: 24px;
    }
    .title-2 {
      font-size: 12px;
      margin-top: 5px;
    }
    .login-field {
      display: flex;
      margin: 0 25px;
      margin-bottom: 20px;
      height: 40px;
      & > span {
        color: white;
        text-align: left;
        line-height: 40px;
        width: 70px;
        display: inline-block;
      }
      & > div {
        width: calc(100% - 70px);
      }
      .login-code {
        display: flex;
        & > span {
          width: 140px;
          margin-left: 10px;
          background: white;
        }
      }
    }
    .login-submit {
      margin: 0 25px;
      /deep/.van-button {
        width: 100%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Login/Login.vue